import React, { useState } from 'react'
import { SearchNormal1 } from 'iconsax-react'
import { Link } from 'react-router-dom'
import { MdManageAccounts } from "react-icons/md";
import { FaArrowLeftLong, FaArrowUp } from "react-icons/fa6";
import { IoCard } from "react-icons/io5";
import { GiSwipeCard } from "react-icons/gi";
import { ChevronDown } from 'lucide-react';
import { LuArrowUpDown } from "react-icons/lu";
import CTAButton from '../../components/CTA/CTAButton';
import { Helmet } from "react-helmet-async";
import { cardplotFaqs, faqData } from './HelpData'; 

const iconMap = {
  FaArrowUp: FaArrowUp,
  FaArrowLeftLong: FaArrowLeftLong,
  MdManageAccounts: MdManageAccounts,
  GiSwipeCard: GiSwipeCard,
  LuArrowUpDown: LuArrowUpDown,
  IoCard: IoCard,
};


function HelpCentre() {
    const [openIndex, setOpenIndex] = useState(null);
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <>
            <Helmet>
              <title>Help  Centre | Cardplot</title>
            </Helmet>
            <section className='breadcrumb__section bg-overlay help-center-hero'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h4 className='breadcrumb__text__head'> Hi, how can we help? </h4>
                            </div>
                            <div className="position-relative my-3">
                                <form className="help-search-form d-flex align-items-center rounded-pill border px-3 py-1 bg-white mx-auto">
                                    <SearchNormal1 className="me-2" color="#6c757d" />
                                    <input type="search" name="search" placeholder="Search for articles" className="form-control border-0 shadow-none" style={{ flex: 1 }} />
                                    <button type="submit" className="btn btn-dark btn-sm rounded-pill px-3" style={{ backgroundColor: "#2A0A7D"}}> Search </button>
                                </form>
                            </div>

                            <div className='help__center__breadcrumb'>
                                <h4 className='help__center__breadcrumb__content'>
                                    Login for personalized support
                                </h4>
                                <div className="mt-4">
                                    <a href={`${dashboardBaseUrl}/login`} target="_blank" rel="noopener noreferrer">
                                        Log in
                                    </a>
                                </div>
                            </div>
                            <div className="mt-4 text-center">
                                Trouble logging in? &nbsp;
                                <a className='small-loggin' href={`${dashboardBaseUrl}/password-reset`} target="_blank" rel="noopener noreferrer">
                                    Reset Password
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className='help__center__section faq-list-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 my-5'>
                            <h2 className='help__center__section__title'>Cardplot FAQs</h2>
                        </div>
                    </div>
                    <div className='row faq-list'>
                        {cardplotFaqs.map((faq, index) => (
                            <div key={index} className="help__center__section__button">
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className={`d-flex justify-content-between align-items-center text-left ${openIndex === index ? 'button-open' : ''}`}
                                >
                                    <span className="faq-question">{faq.question}</span>
                                    <ChevronDown
                                        className={`chevron-down ${openIndex === index ? 'rotate-180' : ''}`}
                                    />
                                </button>
                                <div className={`accordion-content ${openIndex === index ? 'open' : 'closed'}`}>
                                    <p className="whitespace-pre-line">{faq.answer}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='browser__by__category__section padding__tb__50'>
                <div className="page__width__1200">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                            <h2 className='browser__by__category__section__title'>Browse by Category</h2>
                            </div>
                        </div>

                        <div className='browser__by__category__box'>
                            {faqData.map((item) => {
                            const Icon = iconMap[item.icon] || FaArrowUp;

                            return (
                                <Link key={item.id} to={`/help/category/${item.slug}`} className='browser__by__category__item' >
                                    <div className='browser__by__category__item__icon'>
                                        <Icon className={item.icon === "FaArrowUp" ? "arrow__up" : ""} />
                                    </div>
                                    <div className='browser__by__category__item__content'>
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </Link>
                            );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className='browser__by__category__section padding__tb__50'>
                <div className="page__width__1200">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h2 className='browser__by__category__section__title'>Browse by Category</h2>
                            </div>
                        </div>
                        <div className='browser__by__category__box'>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <FaArrowUp className='arrow__up' />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Sending Money</h4>
                                    <p>Setting up, payments, editing and cancelling transfers</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <MdManageAccounts />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Account Management</h4>
                                    <p>Setting up your account and getting verified</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <GiSwipeCard />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Holding Money</h4>
                                    <p>Holding Balances, direct debits, investments and stock options</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <GiSwipeCard />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Holding Money</h4>
                                    <p>Holding Balances, direct debits, investments and stock options</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <LuArrowUpDown />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Currency Conversion</h4>
                                    <p>Rates, Daily updates, arbitrage, etc</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <FaArrowLeftLong className='arrow__up__down' />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Receiving Money</h4>
                                    <p>Setting up your account and getting verified</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <IoCard />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Virtual Cards</h4>
                                    <p>Ordering, activating, spending and troubleshooting</p>
                                </div>
                            </div>
                            <div className='browser__by__category__item'>
                                <div className='browser__by__category__item__icon'>
                                    <IoCard />
                                </div>
                                <div className='browser__by__category__item__content'>
                                    <h4>Virtual Cards</h4>
                                    <p>Ordering, activating, spending and troubleshooting</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <CTAButton />
        </>
    )
}

export default HelpCentre
